export function downloadFile(data: Blob, filename: string): void {
    const file = new File([data], filename, { type: data.type });
    const url = URL.createObjectURL(file);

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;

    document.body.appendChild(a);

    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}
